import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { styled } from '@mui/material/styles';
import { AppBar, Grid, Divider, Box, Typography, List, ListItem, ListItemText, IconButton, } from '@mui/material';
import { Link as RouterLink, } from 'react-router-dom';
import X from '@mui/icons-material/X';
import Instagram from '@mui/icons-material/Instagram';
import Facebook from '../icons/Facebook';
const StyledDivider = styled(Divider)(({ theme }) => ({
    //   height: '50px',
    borderColor: theme.portal.site.lineColor,
    margin: '0 20px 0',
}));
const Title = ({ text }) => (_jsx(Typography, { className: "footerHeading", children: text }));
const ListItemLink = (props) => {
    const { primary, to, src, imageStyle, } = props;
    const renderLink = React.useMemo(
    // eslint-disable-next-line react/no-unstable-nested-components
    () => React.forwardRef((itemProps, ref) => _jsx(RouterLink, { to: to, ref: ref, ...itemProps, role: undefined })), [to]);
    return (_jsx("li", { style: { marginTop: '6px', marginBottom: '6px' }, children: _jsxs(ListItem, { disablePadding: true, component: renderLink, children: [primary && (_jsx(ListItemText, { disableTypography: true, sx: { m: 0 }, primary: (_jsx(Typography, { variant: "caption", className: "footerListItemText", children: primary })) })), src && _jsx("img", { src: src, style: { ...imageStyle, marginLeft: '-14px' }, alt: "alt" })] }) }));
};
ListItemLink.defaultProps = {
    src: undefined,
    imageStyle: undefined,
    primary: undefined,
};
const FooterBar = ({ 
// eslint-disable-next-line no-empty-pattern
settings: { showTitles, showSeparators, }, limitToPageWidth, }) => {
    const footerItems = [
        {
            id: 0,
            title: 'About Us',
            items: [
                {
                    id: '00', type: 'link', to: '#', text: 'What We Offer',
                },
                {
                    id: '01', type: 'link', to: '#', text: 'Leadership',
                },
                {
                    id: '02', type: 'link', to: '#', text: 'Careers',
                },
                {
                    id: '03', type: 'link', to: '#', text: 'Catalog',
                },
                {
                    id: '04', type: 'link', to: '#', text: 'Enterprise Plus Plus',
                },
                {
                    id: '05', type: 'link', to: '#', text: 'Professional Certificates',
                },
            ],
        },
        {
            id: 1,
            title: 'Courses',
            items: [
                {
                    id: '10', type: 'link', to: '#', text: 'MasterTrack® Certificates',
                },
                {
                    id: '11', type: 'link', to: '#', text: 'Degrees',
                },
                {
                    id: '12', type: 'link', to: '#', text: 'For Enterprise',
                },
                {
                    id: '13', type: 'link', to: '#', text: 'For Government',
                },
                {
                    id: '14', type: 'link', to: '#', text: 'For Campus',
                },
                {
                    id: '15', type: 'link', to: '#', text: 'Become a Partner',
                },
            ],
        },
        {
            id: 2,
            title: 'Connect with us',
            items: [
                {
                    id: '20', type: 'iconBtn', onClick: () => { }, icon: _jsx(Facebook, {}),
                },
                {
                    id: '21', type: 'iconBtn', onClick: () => { }, icon: _jsx(X, {}),
                },
                {
                    id: '22', type: 'iconBtn', onClick: () => { }, icon: _jsx(Instagram, {}),
                },
            ],
        },
        {
            id: 3,
            title: 'Mobile App',
            items: [
                {
                    id: '30', type: 'link', to: '#', text: 'Download on the App Store',
                },
                {
                    id: '31',
                    type: 'imageLink',
                    to: '#',
                    src: 'https://developer.apple.com/news/images/download-on-the-app-store-badge.png',
                    style: {
                        padding: '14px',
                        width: '200px',
                        height: '85.375px',
                        marginTop: '-14px',
                    },
                },
                {
                    id: '32', type: 'link', to: '#', text: 'Get it on Google Play',
                },
                {
                    id: '33',
                    type: 'imageLink',
                    to: '#',
                    src: 'https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png',
                    style: {
                        width: '200px',
                        height: '85.41px',
                        marginTop: '-14px',
                    },
                },
            ],
        },
    ];
    const handleClick = () => {
        console.log('handle click');
    };
    return (_jsx(AppBar, { position: "relative", sx: {
            boxShadow: '0 0 9px 0 rgba(75, 75, 75, 0.11)',
            py: 2.5,
            px: 5,
            ...(limitToPageWidth && {
                maxWidth: 1200,
                marginX: 'auto',
            }),
            backgroundColor: (t) => (t.portal.footer.background.color),
        }, children: _jsx(Grid, { container: true, children: footerItems.map((item, index) => (_jsxs(Grid, { item: true, xs: 12, sm: 6, md: 3, display: "flex", children: [showSeparators && _jsx(StyledDivider, { orientation: "vertical" }), _jsxs(Box, { sx: { width: '100%', mt: { xs: index > 1 ? 1 : 0, lg: 0 } }, children: [showTitles && _jsx(Title, { text: item.title }), _jsx(List, { disablePadding: true, sx: {
                                    width: '100%',
                                    pl: 0.25,
                                }, children: item.items.map((subItem) => (_jsxs(React.Fragment, { children: [subItem.type === 'link' && (_jsx(ListItemLink, { to: subItem.to, primary: subItem.text })), subItem.type === 'iconBtn' && (_jsx(IconButton, { onClick: handleClick, sx: { color: (theme) => theme.palette.indigoCustom[700], mx: 1 }, children: subItem.icon })), subItem.type === 'imageLink' && (_jsx(ListItemLink, { to: subItem.to, src: subItem.src, imageStyle: subItem.style }))] }, subItem.id))) })] })] }, item.id))) }) }));
};
FooterBar.defaultProps = {
    settings: {
        showTitles: true,
        showSeparators: true,
    },
};
FooterBar.meta = {
    group: 'portal',
    name: 'Portal Foot Bar',
    description: 'Bottom global Bar for contact buttons',
    props: [
        {
            key: 'course',
            name: 'Course',
            type: 'course', // note this is a special type recognized by the system
            description: 'The course to display information about',
        },
        {
            key: 'settings.showTitles',
            name: 'Show titles',
            type: 'boolean',
            description: 'Show titles of footer sections.',
        },
        {
            key: 'settings.showSeparators',
            name: 'Show separators',
            type: 'boolean',
            description: 'Show separators between sections.',
        },
        {
            key: 'settings.showAboutUs',
            name: 'Show about us section',
            type: 'boolean',
            description: 'Show about us section.',
        },
        {
            key: 'settings.showCourses',
            name: 'Show courses section',
            type: 'boolean',
            description: 'Show courses section.',
        },
        {
            key: 'settings.showConnect',
            name: 'Show connect with us Section',
            type: 'boolean',
            description: 'Show connect with us section.',
        },
        {
            key: 'settings.showMobileApp',
            name: 'Show mobile app section',
            type: 'boolean',
            description: 'Show mobile apps section.',
        },
        {
            key: 'settings.showFacebookBtn',
            name: 'Show Facebook Button',
            type: 'boolean',
            description: 'Show the Facebook contact button on app footer.',
        },
        {
            key: 'settings.showTwitterBtn',
            name: 'Show Twitter Button',
            type: 'boolean',
            description: 'Show the Twitter contact button on app footer.',
        },
        {
            key: 'settings.showInstagramBtn',
            name: 'Show Instrgram Button',
            type: 'boolean',
            description: 'Show the Instagram contact button on app footer.',
        },
        {
            key: 'settings.showAppStoreText',
            name: 'Show Apple store text',
            type: 'boolean',
            description: 'Show the Apple store text in mobile app section.',
        },
        {
            key: 'settings.showAppStoreImage',
            name: 'Show Apple store image',
            type: 'boolean',
            description: 'Show the Apple store image in mobile app section.',
        },
        {
            key: 'settings.showPlayStoreText',
            name: 'Show Google Play store text',
            type: 'boolean',
            description: 'Show the Google Play store text in mobile app section.',
        },
        {
            key: 'settings.showPlayStoreImage',
            name: 'Show Google Play store image',
            type: 'boolean',
            description: 'Show the Google Play store image in mobile app section.',
        },
        {
            key: 'limitToPageWidth',
            name: 'Limit Width',
            type: 'boolean',
            description: 'Limit the width of the stack to the maximum page width',
        },
    ],
    defaultConfig: {
        type: 'component',
        component: 'FooterBar',
        props: {
            settings: {
                showTitles: true,
                showSeparators: true,
                showAboutUs: true,
                showCourses: true,
                showConnect: true,
                showMobileApp: true,
                showFacebookBtn: true,
                showTwitterBtn: true,
                showInstagramBtn: true,
                showAppStoreText: true,
                showAppStoreImage: true,
                showPlayStoreText: true,
                showPlayStoreImage: true,
                limitToPageWidth: true,
            },
        },
    },
};
export default FooterBar;
//# sourceMappingURL=FooterBar.js.map